'use client';

import { MDSTextInput } from '../TextInput/TextInput';
import { ComponentProps, forwardRef } from 'react';
import { OnValueChange, PatternFormat } from 'react-number-format';

type Props = Omit<
  ComponentProps<typeof MDSTextInput>,
  'onChange' | 'inputType'
> & {
  onChange: OnValueChange;
  format?: string;
};

/**
 ```jsx
 import { MDSPhoneInput } from '@midwest/web/forms';
 ```
 * Wrapper for the [Text Input](../?path=/docs/inputs-controls-text-input--docs) component with added formatting for inputting phone numbers.
 * By default will display as ###-###-####.
 */
export const MDSPhoneInput = forwardRef<HTMLInputElement, Props>(
  ({ onChange, format = '###-###-####', ...props }, ref) => {
    return (
      <PatternFormat
        type="tel"
        valueIsNumericString={true}
        format={format}
        customInput={MDSTextInput}
        onValueChange={onChange}
        getInputRef={ref}
        {...props}
      />
    );
  },
);

MDSPhoneInput.displayName = 'MDSPhoneInput';
